export default __webpack_public_path__ + "static/media/shlomi-shabat_yesh-lach.b1a01d83.mp3";